import React from "react";

const AllocationsIntegrationIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M25 7.5H21V11.5H25V7.5ZM21 14.5H25V18.5H21V14.5ZM25 21.5H21V25.5H25V21.5ZM25 28.5H21V32.5H25V28.5Z",
  fill: "#72CFED"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14 14.5H18V18.5H14V14.5ZM11 21.5H7V25.5H11V21.5ZM0 28.5H4V32.5H0V28.5ZM7 28.5H11V32.5H7V28.5ZM14 28.5H18V32.5H14V28.5ZM18 21.5H14V25.5H18V21.5ZM32 28.5H28V32.5H32V28.5ZM28 21.5H32V25.5H28V21.5ZM39 28.5H35V32.5H39V28.5ZM35 21.5H39V25.5H35V21.5ZM39 14.5H35V18.5H39V14.5Z",
  fill: "#00AEEF"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(AllocationsIntegrationIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;